import React, { CSSProperties, DetailedHTMLProps, forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Skeleton.module.scss';

export interface ISkeletonProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    height?: CSSProperties['height'];
    width?: CSSProperties['width'];
}

export const Skeleton = forwardRef<HTMLDivElement, ISkeletonProps>(
    ({ height = '100%', width = '100%', className, style, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={classNames(styles.loadingSkeleton, className)}
                style={{
                    ...style,
                    height,
                    width,
                }}
                {...props}
            />
        );
    },
);
